import React from "react";
import styles from "./Style.module.css";
import PropTypes from "prop-types";
import useAppUsersDetailHook from "./AppUsersDetail.Hook";
import { AppBar, Box, ButtonBase, Tab, Tabs, Typography } from "@mui/material";
import { ArrowBackIos, Edit } from "@mui/icons-material";
import history from "../../../libs/history.utils";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import StatusPill from "../../../components/Status/StatusPill.component";
import ReportedSideEffectsList from "./ReportedSideEffects/ReportedSideEffectsList.view";
import AppProgramsTable from "./AppPrograms/AppProgramsTable.component";
import DataAccordion from "./DataAccordion/DataAccordion.view";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      // aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div>
          <div>{children}</div>
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const AppUsersDetail = () => {
  const { value, handleChange, handleEdit, appUserDetails, programData } =
    useAppUsersDetailHook({});

  return (
    <>
      <div className="container">
        <div className={styles.headerContainer}>
          <div className={styles.iconButton}>
            <ButtonBase onClick={() => history.goBack()}>
              <ArrowBackIos fontSize={"small"} />{" "}
            </ButtonBase>
            <Typography variant={"h4"}>App User Details</Typography>
          </div>
        </div>
        <ShadowBox className={styles.product}>
          <div className={styles.title}>
            <div className={styles.row}>
              <div className={styles.textContainer}>
                <div className={styles.row1}>
                  <Typography
                    variant={"h5"}
                    className={styles.productHeading}
                    color={"text.primary"}
                  >
                    {`${appUserDetails?.first_name ?? "N/A"} ${
                      appUserDetails?.last_name
                    }`}
                  </Typography>
                  <div className={styles.right}>
                    <StatusPill
                      status={
                        appUserDetails?.status === "INACTIVE"
                          ? "Inactive"
                          : "Active"
                      }
                      color={
                        appUserDetails?.status === "INACTIVE"
                          ? "high"
                          : "active"
                      }
                    />
                  </div>
                </div>
                <div className={styles.row1}>
                  <Typography
                    variant={"body1"}
                    color={"text.secondary"}
                    className={styles.spacing}
                  >
                    +{appUserDetails?.full_contact ?? "N/A"}
                  </Typography>
                </div>
                <div className={styles.row}>
                  <Typography
                    variant={"body1"}
                    color={"text.secondary"}
                    className={styles.spacing}
                  >
                    {appUserDetails?.email ?? "N/A"}
                  </Typography>
                </div>
                <div className={styles.row}>
                  <Typography
                    variant={"body1"}
                    color={"text.secondary"}
                    className={`${styles.spacing} ${styles.url}`}
                  >
                    Last login:
                  </Typography>
                  <Typography
                    variant={"subtitle1"}
                    className={styles.link}
                    sx={{ ml: 1 }}
                  >
                    {appUserDetails?.lastLoginText ?? "N/A"}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </ShadowBox>

        <div className={styles.tab}>
          <AppBar position="static" className={styles.backgroundColor}>
            <Tabs
              value={value}
              onChange={handleChange}
              sx={{ marginLeft: "8px" }}
              indicatorColor="secondary"
              textColor="secondary"
            >
              <Tab label={`Programs (${programData?.length || 0})`} className={styles.tabsTitle} />
              <Tab label="Rewards Earned" className={styles.tabsTitle} />
              <Tab label="Wallet History" className={styles.tabsTitle} />
              <Tab label="Reported Side Effects" className={styles.tabsTitle} />
            </Tabs>
          </AppBar>

          <div className={styles.paperBackground}>
            <TabPanel value={value} index={0} dir={"ltr"}>
              <AppProgramsTable listData={programData} />
            </TabPanel>
            <TabPanel value={value} index={1} dir={"ltr"}>
              <DataAccordion titles={programData} type="reward" />
            </TabPanel>
            <TabPanel value={value} index={2} dir={"ltr"}>
              <DataAccordion titles={programData} type="wallet" />
            </TabPanel>
            <TabPanel value={value} index={3} dir={"ltr"}>
              <ReportedSideEffectsList />
            </TabPanel>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppUsersDetail;
